import { render, staticRenderFns } from "./SideMenuLarge.vue?vue&type=template&id=0c2fdcaa&scoped=true&"
import script from "./SideMenuLarge.vue?vue&type=script&lang=js&"
export * from "./SideMenuLarge.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuLarge.vue?vue&type=style&index=0&id=0c2fdcaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2fdcaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
